/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {AnimaFadeinTop} from '../../../../_metronic/assets/animation/styles'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {IndemnityItemsListWrapper} from './components/indemnityItems-list/IndemnityItemsList'
import {KTCard} from '../../../../_metronic/helpers'
import {IndemnityItemsListHeader} from './components/indemnityItems-list/components/header/IndemnityItemsListHeader'
import {QueryRequestProvider} from './components/indemnityItems-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './components/indemnityItems-list/core/QueryResponseProvider'
import {ListViewProvider} from './components/indemnityItems-list/core/ListViewProvider'
import {Toolbar2} from '../../../../_metronic/layout/components/toolbar/Toolbar2'

const IndemnityItemPage: FC = () => {
  const intl = useIntl()
  return (
    <>
      <Toolbar2
        icon={true}
        router='/addindemnityitems'
        subtitle={intl.formatMessage({id: 'COMMON.ITEM'})}
      />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'INDEMNITY_ITEM.TITLE'})}</PageTitle>
      <AnimaFadeinTop>
        <QueryRequestProvider>
          <QueryResponseProvider>
            <ListViewProvider>
              <KTCard>
                <div className=''>
                  <IndemnityItemsListHeader />
                </div>
              </KTCard>
              <div className='tab-content' id='myTabContent'>
                <div className='tab-pane fade active show ' id='kt_tab_pane_1' role='tabpanel'>
                  <IndemnityItemsListWrapper />
                </div>
              </div>
            </ListViewProvider>
          </QueryResponseProvider>
        </QueryRequestProvider>
      </AnimaFadeinTop>
    </>
  )
}

export {IndemnityItemPage}
